import { render, staticRenderFns } from "./home-support-manager.vue?vue&type=template&id=3b7b054c&scoped=true"
var script = {}
import style0 from "./home-support-manager.vue?vue&type=style&index=0&id=3b7b054c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b054c",
  null
  
)

export default component.exports